<template>
  <page>
    <div class="access container">
      <div v-if="!loading_confirmation && !loading_terms && !loading">
        <div class="pull-right" v-if="confirmed">
          <a href @click.prevent="selectLang('en')"><img src="../assets/flag-gb.png" width="20px"/></a>
          <a href @click.prevent="selectLang('is')"><img src="../assets/flag-is.png" width="20px"/></a>
        </div>

        <table class="table" v-if="confirmed">
          <thead>
            <tr>
              <th style="width: 5%;"></th>
              <th style="width: 30%;">
                <span v-if="lang == 'en'">Name</span>
                <span v-else>Nafn</span>
              </th>
              <th class="hidden-xs" style="width: 15%;">
                <span v-if="lang == 'en'">Ssn</span>
                <span v-else>Kennitala</span>
              </th>
              <th style="width: 15%;">
                <span v-if="lang == 'en'">Status</span>
                <span v-else>Staða</span>
              </th>
              <th class="hidden-xs" style="width: 35%;">
                <span v-if="lang == 'en'">School</span>
                <span v-else>Skóli</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="5"><i>Augnablik...</i></td>
            </tr>
            <tr v-if="!loading && (!accessList || accessList.length === 0)">
              <td colspan="5"><i>Enginn virkur aðgangur að Innu finnst á innskráðum notanda</i></td>
            </tr>
            <template v-if="!loading && accessList">
              <tr v-for="(a, idx) in accessList" :key="idx">
                <td><div v-bind:class="['select-system-' + a.system]"></div></td>
                <td>
                  <span v-if="!!a.is_access"
                    ><a href v-on:click.prevent="select(idx)"
                      >{{ a.name }} <span class="visible-xs-inline">({{ a.ssn }})</span></a
                    ></span
                  >
                  <span v-if="!a.is_access"
                    >{{ a.name }} <span class="small text-danger">Aðgangur þessa notanda er lokaður - {{ a.comment }}</span></span
                  >
                </td>
                <td class="hidden-xs">{{ a.ssn }}</td>
                <td>
                  {{ a.status_name }} <span class="visible-xs-inline">, {{ a.school.name }}</span>
                </td>
                <td class="hidden-xs">{{ a.school.name }}</td>
              </tr>
            </template>
          </tbody>
        </table>
        <div v-else>
          <div class="row">
            <div class="col-md-6">
              <h4>
                <span v-if="lang == 'en'">Inna's Privacy Policy</span>
                <span v-else> Persónuverndarstefna Innu</span>
              </h4>
              <div>
                <i>
                  <span v-if="lang == 'en'">You have yet to agree to Inna's Privacy Policy</span>
                  <span v-else>Þú átt eftir að samþykkja persónuverndarstefnu Innu</span>
                </i>
              </div>
            </div>
            <div class="col-md-6">
              <div class="pull-right">
                <a href @click.prevent="selectLang('en')"><img src="../assets/flag-gb.png" width="20px"/></a>
                <a href @click.prevent="selectLang('is')"><img src="../assets/flag-is.png" width="20px"/></a>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div style="border:4px solid #ddd;padding:20px;">
            <div v-html="termsEn" v-if="lang == 'en'"></div>
            <div v-html="terms" v-else></div>
          </div>
          <br />
          <br />
          <button class="btn btn-primary" @click.prevent="confirm()" :disabled="confirming">
            <span v-if="lang == 'en'">Agree now</span>
            <span v-else>Samþykkja núna</span>
          </button>
          <button class="btn" @click.prevent="goToAccess" :disabled="confirming">
            <span v-if="lang == 'en'">Agree later</span>
            <span v-else>Samþykkja síðar</span>
          </button>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </page>
</template>

<script>
/* global alert: false, window: false */

import config from '../services/config'
import auth from '../services/auth'

export default {
  name: 'access',
  data() {
    return {
      loading_confirmation: false,
      loading_terms: false,
      loading: false,
      confirmed: false,
      confirming: false,
      terms: '',
      termsEn: '',
      accessList: null,
      lang: 'is'
    }
  },
  methods: {
    loadTerms() {
      this.loading_terms = true
      this.$http
        .get(config.USER_TERMS, {
          headers: auth.getAuthHeader()
        })
        .then(
          response => {
            this.loading_terms = false
            this.terms = response.data.terms
            this.termsEn = response.data.terms_ens
          },
          err => {
            this.loading_terms = false
            alert('Óvænt villa (' + err.status + ') kom upp. Vinsamlegast reyndu aftur.')
          }
        )
    },
    loadTermsConfirmed() {
      this.loading_confirmation = true
      this.$http
        .get(config.USER_TERMS_CONFIRMED, {
          headers: auth.getAuthHeader()
        })
        .then(
          response => {
            this.loading_confirmation = false
            this.confirmed = response.data.confirmed
            if (response.data.confirmed) {
              if (this.accessList.length === 1) {
                if (this.accessList[0].is_access) {
                  this.select(0)
                }
              }
            } else {
              this.loadTerms()
            }
          },
          err => {
            this.loading_confirmation = false
            alert('Óvænt villa (' + err.status + ') kom upp. Vinsamlegast reyndu aftur.')
          }
        )
    },
    loadAccess() {
      this.loading = true
      this.$http
        .get(config.ACCESS_URL, {
          params: {
            callback_url: this.callbackUrl,
            callback_system: this.callbackSystem
          },
          headers: auth.getAuthHeader()
        })
        .then(
          response => {
            if (typeof response.data === 'object' && 'url' in response.data) {
              auth.logout()
              window.location = response.data.url
            } else {
              this.loading = false
              this.accessList = response.data
              this.loadTermsConfirmed()

              /* if (this.accessList.length === 1) {
              if (this.accessList[0].is_access) {
                this.select(0)
              }
            } */
            }
          },
          err => {
            this.loading = false
            alert('Óvænt villa (' + err.status + ') kom upp. Vinsamlegast reyndu aftur.')
          }
        )
    },
    select(idx) {
      var params = {
        i: idx,
        system: this.accessList[idx].system,
        user_id: this.accessList[idx].user_id,
        status: this.accessList[idx].status
      }

      if (this.callbackSystem1Url) {
        params.callback_system_1_url = this.callbackSystem1Url
      }

      this.loading = true
      this.$http
        .post(
          config.SYSTEM_URL,
          {},
          {
            headers: auth.getAuthHeader(),
            params: params
          }
        )
        .then(
          response => {
            auth.logout()
            window.location = response.data.url
          },
          err => {
            this.loading = false
            alert('Óvænt villa (' + err.status + ') kom upp. Vinsamlegast reyndu aftur.')
          }
        )
    },
    goToAccess() {
      this.confirmed = true
      if (this.accessList.length === 1) {
        if (this.accessList[0].is_access) {
          this.select(0)
        }
      }
    },
    confirm() {
      this.confirming = true
      this.$http
        .get(config.CONFIRM_USER_TERMS, {
          headers: auth.getAuthHeader()
        })
        .then(
          response => {
            this.goToAccess()
          },
          err => {
            this.confirming = false
            alert('Óvænt villa (' + err.status + ') kom upp. Vinsamlegast reyndu aftur.')
          }
        )
    },
    selectLang(lang) {
      this.lang = lang
    }
  },
  created() {
    this.callbackUrl = 'c' in this.$route.query ? this.$route.query.c : null
    this.callbackSystem = 's' in this.$route.query ? this.$route.query.s : null
    this.callbackSystem1Url = 'c1' in this.$route.query ? this.$route.query.c1 : null

    this.loadAccess()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.select-system-0 {
  width: 16px;
  height: 16px;
  background: url('../assets/inna_logo_old_small.png');
}
div.select-system-1 {
  width: 16px;
  height: 16px;
  background: url('../assets/inna_logo_new_small.png');
}
div.select-system-2 {
  width: 16px;
  height: 16px;
  background: url('../assets/inna_logo_admin_small.png');
}
div.select-system-3 {
  width: 16px;
  height: 16px;
  background: url('../assets/inna_logo_applications_small.png');
}
</style>
